// extracted by mini-css-extract-plugin
export default {"detailModal":"DetailEnergyModal_detailModal__tgTdC"};